export default __webpack_public_path__ + "static/media/pawn_queen_medusa_fox.657d58a1.png";